import { forwardRef, useState } from 'react';

import { Color, Map, Size } from '@/type';

const ColorSetting: Map[] = [
  {
    key: 'primary',
    class: [
      'text-white',
      'bg-[#6667A0]', // TODO: 今後、tailwind.config.jsのNavyで管理したい。
      'hover:bg-[#333581]',
      'focus:bg-[#1A1B71]',
      'focus:ring-Navy-700',
      'border-none',
      'focus:ring-2',
      'focus:ring-offset-2',
    ],
  },
  {
    key: 'default',
    class: [
      'text-gray-700',
      'bg-white',
      'hover:bg-gray-100',
      'focus:ring-Navy-500',
      'border-gray-300',
      'focus:ring-2',
      'focus:ring-offset-2',
    ],
  },
  {
    key: 'danger',
    class: [
      'text-white',
      'bg-red-600',
      'hover:bg-red-700',
      'focus:ring-red-500',
      'border-transparent',
      'focus:ring-2',
      'focus:ring-offset-2',
    ],
  },
  {
    key: 'text',
    class: ['text-Navy-600', 'hover:text-Navy-800', 'border-transparent'],
  },
  {
    key: 'textDefault',
    class: ['border-none'],
  },
  {
    key: 'textDanger',
    class: ['text-red-500', 'border-transparent', 'focus:outline-none'],
  },
  {
    key: 'tag',
    class: ['bg-blue-100', 'hover:bg-blue-200'],
  },
  {
    key: 'warn',
    class: [
      'bg-yellow-500',
      'hover:bg-yellow-600',
      'text-white',
      'focus:ring-2',
      'focus:ring-offset-2',
      'focus:ring-Navy-500',
    ],
  },
];

const SizeSetting: Map[] = [
  { key: 'initial', class: ['text-sm'] },
  { key: 'small', class: ['py-2', 'px-4', 'text-sm'] },
  { key: 'medium', class: ['py-2', 'px-4', 'text-base'] },
  { key: 'large', class: ['py-3', 'px-6', 'text-[16px]'] },
];

const WidthSetting: Map[] = [
  { key: 'default', class: [''] },
  { key: 'setting', class: ['min-w-[160px]'] },
  { key: 'answerEdit', class: ['w-[100px]'] },
];

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children?: React.ReactNode;
  color?: Color;
  size?: Size;
  fullWidth?: boolean;
  width?: string;
  classes?: string[];
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  isAlignLeft?: boolean;
};

const Button = forwardRef<HTMLButtonElement, Props>(
  (
    {
      children,
      color = 'default',
      size = 'small',
      fullWidth = false,
      width = 'default',
      classes = [],
      onClick,
      isAlignLeft = false,
      ...props
    },
    ref,
  ): JSX.Element => {
    const targetColor = ColorSetting.find((item) => item.key === color).class;
    const targetSize = SizeSetting.find((item) => item.key === size).class;
    const targetWidth = WidthSetting.find((item) => item.key === width).class; // TODO:設定画面用で追加。今後、既存のfullWidthと合体させたい。

    const className = [
      'focus:outline-none',
      'inline-flex',
      isAlignLeft ? 'justify-start' : 'justify-center',
      'items-center',
      'rounded-md',
      'border',
      'focus:outline-none',
      size === 'initial' ? '' : 'whitespace-nowrap',
      ...targetColor,
      ...targetSize,
      ...targetWidth,
      ...classes,
    ].join(' ');
    const [processing, setProcessing] = useState(false);

    const handleSubmit = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
      if (onClick && !processing) {
        setProcessing(true);
        onClick(event);
        setProcessing(false);
      }
    };

    return (
      <button
        ref={ref}
        {...props}
        className={`${className} ${fullWidth ? 'w-full' : ''} ${
          props.disabled ? 'opacity-50 cursor-not-allowed' : ''
        } `}
        onClick={handleSubmit}
      >
        {children}
      </button>
    );
  },
);

Button.displayName = 'Button';
export default Button;
